<template>
    <div class="Mrliu">
        <div class="h-content">
            <div class="content-left">
                <el-tabs tab-position="left" style=" height: auto;overflow:auto;margin-left: 1.7%" @tab-click='visitDoctor'>
                    <el-tab-pane v-for="(item,index) in doctor" :key="index" :label="item.name">
                      <div class="content-right" style="overflow:auto;">
                          <router-view :dId='dId'></router-view> 
                      </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
  import "../../assets/css/style1.css";

  export default {
    name: "home",
    data: function () {
      return {
        doctor: [],                    //  就诊医生
        dId: 0
      };
    },
    methods: {
      visitDoctor(tab) {
        console.log(tab.index);
        let doctorId = this.doctor[tab.index];       //  当前点击医生id
        if (doctorId != '') {
          this.dId = doctorId;
        }
      },
    },
    created() {
      this.$axios({
        url: "/api/user/usersByRolename",
        method: "GET",
        params: {
          rolename: '医生'
        }
      }).then(res => {
        let resData = res.data.data;
        this.doctor = resData;
        this.dId = resData[0];
      }).catch(err => {
        console.log(err);
      });
    }
  };
</script>

<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
body {
  background-color: #f6f6f6;
}
.h-content{
  margin: 0px;
}
.doctorTitle {
  line-height: 60px;
}
.content-left{
  overflow: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Mrliu.vue?3d08e59f